import React, { useState } from 'react';
import CustomSearchForm from "../../Components/SearchComponent";
import { isMobile } from "react-device-detect";
function CustomMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };
  return (
    <nav style={{
      background: 'linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%)',
      padding: '0.75rem 0',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
      position: 'relative',
      zIndex: 1030
    }}>
      <div style={{
        maxWidth: '1320px',
        margin: '0 auto',
        padding: '0 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative'
      }}>
        {/* Brand */}
        <a 
          href="/en/" 
          style={{
            color: '#ffffff',
            fontSize: '1.4rem',
            fontWeight: 900,
            textDecoration: 'none',
            marginRight: '1rem'
          }}
        >
          Do Calculate
        </a>
        {/* Mobile Search */}
        {isMobile && (
          <div style={{
            flex: 1,
            maxWidth: '200px',
            margin: '0 10px'
          }}>
            <CustomSearchForm isEnglish={true} isMenuBar={true} />
          </div>
        )}
        {/* Hamburger Toggle */}
        <button
          onClick={toggleMenu}
          aria-label="Toggle menu"
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '10px',
            color: '#ffffff',
            fontSize: '1.25rem',
            padding: '0.4rem 0.6rem',
            minWidth: '40px',
            cursor: 'pointer',
            display: 'none'
          }}
          className="navbar-toggle"
        >
          <span style={{
            display: 'inline-block',
            width: '2em',
            height: '1.2em',
            verticalAlign: 'middle',
            backgroundImage: 'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 30 30\'%3E%3Cpath stroke=\'rgba(255, 255, 255, 0.75)\' stroke-linecap=\'round\' stroke-miterlimit=\'10\' stroke-width=\'2\' d=\'M4 7h22M4 15h22M4 23h22\'/%3E%3C/svg%3E")',
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%'
          }}></span>
        </button>
        {/* Menu Items */}
        <div 
          style={{
            display: isOpen ? 'block' : 'flex',
            alignItems: 'center',
            ...(window.innerWidth <= 991 && isOpen ? {
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              background: 'linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%)',
              borderRadius: '0 0 12px 12px',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '1rem',
              zIndex: 1030
            } : {})
          }}
          className="navbar-menu"
        >
          <div style={{
            display: 'flex',
            flexDirection: window.innerWidth <= 991 ? 'column' : 'row',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            marginLeft: window.innerWidth > 991 ? 'auto' : 0,
            textAlign: window.innerWidth <= 991 ? 'left' : 'left',
            direction: 'ltr'
          }}>
            {[
              { href: "/en/", text: "Main Menu" },
              { href: "/en/all-calculators/", text: "All Calculators" },
              { href: "/en/calculators/", text: "Calculator" },
              { href: "/articles-en/", text: "Articles" },
              { href: "/en/about/", text: "About" },
              { href: "/en/advertise/", text: "Advertise" },
              { href: "/ar/", text: "Arabic" }
            ].map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={closeMenu}
                style={{
                  color: '#ffffff',
                  textDecoration: 'none',
                  padding: window.innerWidth <= 991 ? '0.75rem 1rem' : '0.5rem 0.75rem',
                  display: 'block',
                  fontWeight: 600,
                  borderBottom: window.innerWidth <= 991 ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (window.innerWidth <= 991) {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.borderRadius = '8px';
                  }
                }}
                onMouseLeave={(e) => {
                  if (window.innerWidth <= 991) {
                    e.target.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {item.text}
              </a>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 991px) {
          .navbar-toggle {
            display: block !important;
          }
          .navbar-menu {
            display: ${isOpen ? 'block' : 'none'} !important;
          }
        }
        @media (min-width: 992px) {
          .navbar-toggle {
            display: none !important;
          }
          .navbar-menu {
            display: flex !important;
          }
        }
      `}</style>
    </nav>
  );
}
export default CustomMenu;